var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.9583C5.05835 18.9583 1.04169 14.9417 1.04169 10C1.04169 5.05834 5.05835 1.04167 10 1.04167C14.9417 1.04167 18.9584 5.05834 18.9584 10C18.9584 14.9417 14.9417 18.9583 10 18.9583ZM10 2.29167C5.75002 2.29167 2.29169 5.75001 2.29169 10C2.29169 14.25 5.75002 17.7083 10 17.7083C14.25 17.7083 17.7084 14.25 17.7084 10C17.7084 5.75001 14.25 2.29167 10 2.29167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.7083C9.65833 12.7083 9.375 12.425 9.375 12.0833V7.08333C9.375 6.74166 9.65833 6.45833 10 6.45833C10.3417 6.45833 10.625 6.74166 10.625 7.08333V12.0833C10.625 12.425 10.3417 12.7083 10 12.7083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 13.5417C9.84166 13.5417 9.68333 13.4833 9.55833 13.3583L7.05833 10.8583C6.81666 10.6167 6.81666 10.2167 7.05833 9.975C7.29999 9.73333 7.69999 9.73333 7.94166 9.975L9.99999 12.0333L12.0583 9.975C12.3 9.73333 12.7 9.73333 12.9417 9.975C13.1833 10.2167 13.1833 10.6167 12.9417 10.8583L10.4417 13.3583C10.3167 13.4833 10.1583 13.5417 9.99999 13.5417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.0552d8731fd576e88f8f20cbdb9e9351.svg";
export { ForwardRef as ReactComponent };